<template>
  <div class="main-box banner" :style="{height: bannerHeight+'px', marginTop:mTop+'px'}">
    <el-row>
      <el-col :span="10">
        <el-image ref="diqiu" class="diqiu" :src="require('../assets/img/diqiu.png')"></el-image>
      </el-col>
      <el-col :span="14" class="banner-title">
        <h2 ref="title" v-if="__lang == 'en'">Cutting Edge Research on Emerging Industry</h2>
        <h2 ref="title" v-else>面向产业关键技术的前沿研究</h2>
        <!-- <p>
          由珠海市高新区管委会和中移动珠海分公司共同设立，拥有四大研究中心。
        </p>
        <p>
          以科研平台为纽带，推动 5G 网络在垂直领域的商业化进程。
        </p> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import mixin from "../mixin.js";
export default {
  name: "banner",
  mixins:[mixin],
  data(){
    return {
      scrollTop: 0,
      wHeight: 600,  
      animateY: 0
    }
  },
  computed:{
    __lang(){
      return this.$route.params.lang || 'zh-CN';
    },
    bannerHeight(){
      if (this.scrollTop>50) {
        return this.wHeight-150;
      }
      return  this.wHeight;
    },
    mTop() {
      return (this.wHeight-500)/2;
    }
  },
  beforeMount() {
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      if (h<600) {
        this.wHeight = 600 - 120;
      } else {
        this.wHeight = h - 120;
      }
  },
  methods:{
    scrollHandler() {
      const scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      this.scrollTop = scrollTop;
    }
  },
  mounted() {
    setTimeout(()=>{
      const dTitle = this.$refs.title;
      const dDiqiu = this.$refs.diqiu;
      dTitle.style.transform = "translateY(-100px)";
      dDiqiu.$el.style.transform = "translateY(100px)";
    },100);
  }
  
};
</script>

<style lang="less">
  .banner {
    height: 600px;
  }
  .diqiu {
    width: 500px;
    transition: 1s;
    margin-top:-100px;
  }
  .banner-title {
    h2{
      transition: 1s;
      font-size: 46px;
      padding-left: 10px;
      border-left: 5px solid #d22c1d;
      margin-top: 280px;
    }
    p {
      color: #444;
    }
  }
</style>
